export default "__VITE_ASSET__Ddi$8muE__"